export const choreViewTranslateEn = {
    DETAILS_CHORES:{
        AMOUNT_LABEL: "Reward amount",
        PROOF_LABEL: "’s Image Proof",
        DESCRIPTION_LABEL: "Chore description",
        DEADLINE_LABEL: "Deadline",
        APPROVED_BUTTON : "Approve & send reward",
        REJECTED_BUTTON : "Reject",
        PAY_REWARD_BUTTON : "Pay reward"
    },
    REJECT:{
        TOAST:{
          DETAIL_PART_1: "Chore was rejected, we'll let",
          DETAIL_PART_2: "know you didn't approve it"
        }
      }
}